import { Navigate, Route, Routes } from 'react-router-dom';
import { RoutePaths, SessionStorageUtils } from '@shared/utils';
import { PrivateRoute } from './privateRoute';
import {
  AccountsPage,
  ApplyNowPage,
  Cards,
  ContactUs,
  Dashboard,
  LoginPage,
  Messages,
  PasswordResetForm,
  PaymentsPage,
  RecoveryPage,
  RecoveryResetPick,
  RecoveryResetUsernameForm,
} from '@pages/index';

export const Root = () => {
  const icaState = SessionStorageUtils.getIcaState();

  return (
    <Routes>
      {/* AUTH */}
      <Route
        path='/'
        element={icaState?.auth.isAuthorized ? <Navigate to={RoutePaths.dashboard.onNavigate()} /> : <Navigate to={RoutePaths.login.onNavigate()} />}
      />
      <Route path={RoutePaths.login.path} element={<LoginPage />} />
      <Route path={RoutePaths.applyNow.path} element={<ApplyNowPage />} />
      <Route path={RoutePaths.recovery.path} element={<RecoveryPage />}>
        <Route index element={<RecoveryResetPick />} />
        <Route path={RoutePaths.userNameRecovery.path} element={<RecoveryResetUsernameForm />} />
        <Route path={RoutePaths.passwordRecovery.path} element={<PasswordResetForm />} />
      </Route>
      <Route
        path={RoutePaths.dashboard.path}
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.accounts.path}
        element={
          <PrivateRoute>
            <AccountsPage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.cards.path}
        element={
          <PrivateRoute>
            <Cards />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.payments.path}
        element={
          <PrivateRoute>
            <PaymentsPage />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.contactUs.path}
        element={
          <PrivateRoute>
            <ContactUs />
          </PrivateRoute>
        }
      />
      <Route
        path={RoutePaths.messages.path}
        element={
          <PrivateRoute>
            <Messages />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
